"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.combineMedia = exports.resolveThumbByExtension = exports.resolveThumb = void 0;
var GeneralSettings_1 = require("../constants/GeneralSettings");
var MediaSizes_1 = require("../constants/MediaSizes");
var resolveThumb = function (m) {
    if (!m) {
        return;
    }
    var type = m.type, path = m.path;
    if (type === GeneralSettings_1.MEDIA_TYPES.FLOOR_PLAN ||
        type === GeneralSettings_1.MEDIA_TYPES.APARTMENT_PLAN ||
        GeneralSettings_1.MEDIA_TYPES.BUILDING_PLAN) {
        return exports.resolveThumbByExtension(path, MediaSizes_1.MEDIA_SIZES.SINGLE_PROPERTY_PAGE);
    }
    if (type === GeneralSettings_1.MEDIA_TYPES.DOCUMENT) {
        return '/images/pdf-thumb.svg';
    }
    if (type === GeneralSettings_1.MEDIA_TYPES.VIDEO) {
        return '/images/video-thumb.svg';
    }
    return "/r" + path + "?" + MediaSizes_1.MEDIA_SIZES.SINGLE_PROPERTY_PAGE;
};
exports.resolveThumb = resolveThumb;
var resolveThumbByExtension = function (path, size) {
    if (size === void 0) { size = MediaSizes_1.MEDIA_SIZES.SEARCH_PAGE; }
    var _a = path.split('.'), _ = _a[0], ext = _a[1];
    if (ext === 'pdf') {
        return '/images/pdf-thumb.svg';
    }
    if (['mpeg4', 'mp4', '3gp'].includes(ext)) {
        return '/images/video-thumb.svg';
    }
    return "/r" + path + "?" + size;
};
exports.resolveThumbByExtension = resolveThumbByExtension;
var combineMedia = function (postData, isDeveloperTab) {
    var _a;
    if (isDeveloperTab === void 0) { isDeveloperTab = false; }
    if (postData === null || postData === void 0 ? void 0 : postData.sections) {
        var postMedia = isDeveloperTab && ((_a = postData === null || postData === void 0 ? void 0 : postData.developer) === null || _a === void 0 ? void 0 : _a.developer_media)
            ? __spreadArray(__spreadArray([], postData.sections.about_building.media), postData.developer.developer_media) : __spreadArray([], postData.sections.about_building.media);
        postMedia.sort(function (a, b) { return a.building_media_type - b.building_media_type; });
        return (postData === null || postData === void 0 ? void 0 : postData.tour3D)
            ? __spreadArray([postData.tour3D], postMedia) : __spreadArray([], postMedia);
    }
};
exports.combineMedia = combineMedia;
